import { useRouter } from "next/router";

export const useSwitchLanguage = (languages: string[]) => {
  const router = useRouter();
  const currentLang = router.locale;

  const switchLang = (lang: string) => {
    if (lang === currentLang) return;
    const targetLang = languages.find((l) => l === lang);
    if (targetLang) {
      router.push(router.asPath, router.asPath, { locale: targetLang });
    }
  };

  return { switchLang, currentLang };
};

// export const useSwitchLanguage = () => {
//   const router = useRouter();
//   const currentLang = router.locale;
//   const switchLang = (lang: string) => {
//     if (lang === currentLang) return;
//     if (router.locale === "ar") {
//       router.push(router.asPath, router.asPath, { locale: "en" });
//     } else {
//       router.push(router.asPath, router.asPath, { locale: "ar" });
//     }
//   };

//   return { switchLang, currentLang };
// };
